import { render, staticRenderFns } from "./MyAccountModal.vue?vue&type=template&id=12dfd2ae&scoped=true&"
import script from "./MyAccountModal.vue?vue&type=script&lang=js&"
export * from "./MyAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./MyAccountModal.vue?vue&type=style&index=0&id=12dfd2ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfd2ae",
  null
  
)

export default component.exports